export default "__VITE_ASSET__DPqlK51V__"